import { render, staticRenderFns } from "./conferenceList.vue?vue&type=template&id=ac4bd566&"
import script from "./conferenceList.vue?vue&type=script&lang=js&"
export * from "./conferenceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports